import './polyfills';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

declare global {
  interface Window {
    /** Definido por `unsupported-browser.js` (detección temprana). */
    __NF_BROWSER_SUPPORTED__?: boolean;
  }
}

// Si unsupported-browser.js marcó el navegador como no compatible, no arrancar
// Angular (evita errores y deja visible la página estática de aviso).
if (window.__NF_BROWSER_SUPPORTED__ !== false) {
  bootstrapApplication(App, appConfig).catch((err) => console.error(err));
}
